import { createAsyncThunk } from "@reduxjs/toolkit";
import { sendRequestJSON } from "src/lib/axios";
import { toastMessage } from "../commonSlice";
import { CustomerAPIService, LeadAPIService } from "src/constants";
import { ICreateUpdateleadPayload } from "src/pages/lead/type";

export const fetchLeads = createAsyncThunk(
  "leads/fetchLead",
  async (_, { dispatch }) => {
    try {
      const response = await sendRequestJSON(
        null,
        LeadAPIService.GET_LEADS_LIST,
        "get"
      );
      if (!response.error) {
        const { data } = response?.result?.data;
        return data;
      } else {
        dispatch(
          toastMessage({
            error: true,
            message: response.result.message,
          })
        );
        return [];
      }
    } catch (error) {
      dispatch(
        toastMessage({
          error: true,
          message: error.response.data,
        })
      );
      return [];
    }
  }
);

export const fetchLeadIds = createAsyncThunk(
  "leads/fetchLeadIds",
  async (_, { dispatch }) => {
    try {
      const response = await sendRequestJSON(
        null,
        LeadAPIService.GET_LEAD_IDS_LIST,
        "get"
      );
      if (!response.error) {
        const { data } = response?.result?.data;
        return data;
      } else {
        dispatch(
          toastMessage({
            error: true,
            message: response.result.message,
          })
        );
        return [];
      }
    } catch (error) {
      dispatch(
        toastMessage({
          error: true,
          message: error.response.data,
        })
      );
      return [];
    }
  }
);

export const fetchLeadDetailsById = createAsyncThunk(
  "leads/fetchLeadDetailsById",
  async (leadId: string, { dispatch }) => {
    try {
      const response = await sendRequestJSON(
        {
          leadId,
        },
        LeadAPIService.GET_LEAD_BY_ID,
        "post"
      );
      if (!response.error) {
        const { data } = response?.result?.data;
        return data;
      } else {
        dispatch(
          toastMessage({
            error: true,
            message: response.result.message,
          })
        );
        return [];
      }
    } catch (error) {
      dispatch(
        toastMessage({
          error: true,
          message: error.response.data,
        })
      );
      return [];
    }
  }
);

export const createUpdateLead = createAsyncThunk(
  "leads/createUpdateLead",
  async (lead: ICreateUpdateleadPayload, { dispatch }) => {
    try {
      if (lead.leadId) {
        const response = await sendRequestJSON(
          {
            leadId: lead.leadId,
            name: lead.name,
            email: lead.email,
            primaryNumber: lead.primaryNumber,
            secondaryNumber: lead.secondaryNumber,
            gender: lead.gender,
            isCustomer: lead.isCustomer,
            leadChannel: lead.leadChannel,
            branchId: lead.branchId,
          },
          LeadAPIService.CREATE_UPDATE_LEAD,
          "post"
        );

        if (response.error) {
          dispatch(
            toastMessage({
              error: true,
              message: response.result.message,
            })
          );
        } else {
          dispatch(
            toastMessage({
              message: response.result.data.message,
            })
          );
        }

        if (lead.leadId && lead.isCustomer) {
          const customerResponse = await sendRequestJSON(
            {
              customerId: null,
              name: lead.name,
              dob: lead.dob,
              email: lead.email,
              primaryNumber: lead.primaryNumber,
              secondaryNumber: lead.secondaryNumber,
              gender: lead.gender,
              addresses: lead.addresses,
              googleLocation: lead.googleLocation,
              isRecurring: false,
              branchId: lead.branchId,
            },
            CustomerAPIService.CREATE_UPDATE_CUSTOMER,
            "post"
          );

          if (customerResponse.error) {
            dispatch(
              toastMessage({
                error: true,
                message: customerResponse.result.message,
              })
            );
          } else {
            dispatch(
              toastMessage({
                message: customerResponse.result.data.message,
              })
            );
          }
          return customerResponse.result.data;
        }
        return response.result.data;
      }
      // debugger;
      const response = await sendRequestJSON(
        {
          leadId: lead.leadId,
          name: lead.name,
          email: lead.email,
          primaryNumber: lead.primaryNumber,
          secondaryNumber: lead.secondaryNumber,
          gender: lead.gender,
          isCustomer: lead.isCustomer,
          leadChannel: lead.leadChannel,
          branchId: lead.branchId,
        },
        LeadAPIService.CREATE_UPDATE_LEAD,
        "post"
      );
      if (response.error) {
        dispatch(
          toastMessage({
            error: true,
            message: response.result.message,
          })
        );
      } else {
        dispatch(
          toastMessage({
            message: response.result.data.message,
          })
        );
      }
      return response.result.data;
    } catch (error) {
      dispatch(
        toastMessage({
          error: true,
          message: error.response.data,
        })
      );
      return false;
    }
  }
);
